import request from '@/utils/request'
export function getEquipmentInfo(sn) {
  return request({
    url: '/device/getInfo',
    method: 'post',
    data: {
      deviceSn: sn
    },
    params: {
      deviceSn: sn
    }
  })
}

/**
 * 提交意见
 * @param data
 */
export function submit(data) {
  return request({
    url: '/idea/submit',
    method: 'post',
    data
    // params: data
  })
}

/**
 * 发送验证码
 * @param contact
 */
export function sendCode(contact) {
  return request({
    url: '/idea/sendCode',
    method: 'post',
    data: {
      contact: contact
    }
  })
}

/**
 * 校验验证码
 * @param contact
 * @param code
 */
export function checkCode(contact, code) {
  console.log(contact, code)
  return request({
    url: '/idea/verifyCode',
    method: 'post',
    data: {
      contact: contact,
      verifycode: code
    }
  })
}

/**
 * 发送验证码
 * @param contact
 */
export function sendCode2(contact) {
  return request({
    url: '/idea/sendCodeUopinion',
    method: 'post',
    data: {
      contact: contact
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/equipment.js